import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/YoutubeLogo.es.js";
const e = o.forwardRef((t, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...t, weights: m }));
e.displayName = "YoutubeLogoIcon";
const n = e;
export {
  n as YoutubeLogo,
  e as YoutubeLogoIcon
};
